<template>
    <v-modal-slot id="show_clients_modal"
                  size="xl">
        <template v-slot:modal-title>
            Información del cliente
        </template>

        <template v-slot:modal-content>
            <template v-if="loading">
                <div class="loader-container">
                    <div class="loader"></div>
                </div>
            </template>
            <template v-else>
                <div class="row pb-2">
                    <div class="form-group col-5">
                        <div><strong>Número del cliente:</strong></div>
                        <p>{{ client_info.code }}</p>
                    </div>
    
                    <div class="form-group col-7">
                        <div><strong>Nombre:</strong></div>
                        <p>{{ client_info.name }}</p>
                    </div>
                </div>
    
                <div class="row pb-2">
                    <div class="form-group col-5">
                        <div><strong>DNI/NIE:</strong></div>
                        <p>{{ client_info.dni }}</p>
                    </div>
    
                    <div class="form-group col-7">
                        <div><strong>Apellidos:</strong></div>
                        <p>{{ client_info.surname }}</p>
                    </div>
                </div>
    
                <div class="row pb-2">
                    <div class="form-group col-12">
                        <div><strong>Responsable:</strong></div>
                        <p>{{ client_info.responsible ? client_info.responsible.name : '- Sin responsable -' }}</p>
                    </div>
                </div>
    
                <div class="row pb-2">
                    <div class="form-group">
                        <div><strong>Fecha creación:</strong></div>
                        <p>{{ dateToReadable(client_info.creation_date) }}</p>
                    </div>
                </div>
    
                <div class="row">
                    <div class="more-fields row" id="more_fields">
                        <div class="form-group" :class="field.class" v-for="field in fields">
                            <div><strong>{{ field.display_name }}:</strong></div>
                            <p>{{ client_info[field.name] ? client_info[field.name] : '-' }}</p>
                        </div>
                    </div>
                </div>
    
                <div class="row">
                    <div class="form-group col-4">
                        <div><strong>Firmada usura</strong></div>
                        <p>{{ client_info['firmada_usura'] === 'true' ? 'Sí' : 'No' }}</p>
                    </div>
    
                    <div class="form-group col-4">
                        <div><strong>Firmada hipoteca</strong></div>
                        <p>{{ client_info['firmada_hipoteca'] === 'true' ? 'Sí' : 'No' }}</p>
                    </div>
    
                    <div class="form-group col-4">
                        <div><strong>Firmada listas morosidad</strong></div>
                        <p>{{ client_info['firmada_listas_morosidad'] === 'true' ? 'Sí' : 'No' }}</p>
                    </div>
    
                    <div class="form-group col-4">
                        <div><strong>Firmada otras hojas encargo</strong></div>
                        <p>{{ client_info['firmada_otras_hojas_encargo'] === 'true' ? 'Sí' : 'No' }}</p>
                    </div>
    
                    <div class="form-group col-8" v-if="client_info['firmada_otras_hojas_encargo'] === 'true'">
                        <div><strong>Observaciones otras hojas encargo</strong></div>
                        <p>{{ client_info['observaciones_otras_hojas_encargo'] ?? '-' }}</p>
                    </div>
                </div>
            </template>
        </template>
    </v-modal-slot>
</template>

<script>
import VModal from "../../general/VModal";
import VModalSlot from "../../general/VModalSlot";

import { getClient } from "../../../helpers/requests/RequestsClients"

export default {
    name: "ClientsListShowModal",
    components: {VModalSlot, VModal},
    props: {
        client: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            fields: [],
            clientFields: [],
            client_info: this.client,
            loading: false
        }
    },
    mounted() {
        this.fields = require('../../../config/form_fields.json').clients;
        this.getClientInformation();
    },
    methods: {
        /**
         * Reads the dynamic fields configuration file to get the display name to show it.
         *
         * @param dynamic_field_key
         * @returns {*}
         */
        getDynamicFieldDisplayName(dynamic_field_key) {
            let dynamic_fields = require('../../../config/form_fields.json').clients;
            for (let i in dynamic_fields) {
                let dynamic_field = dynamic_fields[i];

                if (dynamic_field.name === dynamic_field_key) {
                    return dynamic_field.display_name;
                }
            }

            // Maybe that key is no more in the field, so what about it? Show it as it came
            return dynamic_field_key;
        },
        async getClientInformation() {
            this.loading = true;
            this.client_info = await getClient(this.client.id);
            this.loading = false;
        },
        dateToReadable(date) {
            if (date) {
                let splitted = date.substr(0, 10).split('-');
                return splitted[2] + '/' + splitted[1] + '/' + splitted[0];
            }
        },
        closeModal() {
            this.$emit('closed');
        }
    }
}
</script>
